import type { TableDefinitionOutputV1 } from '../../target/generated/sdk/model/TableDefinitionOutputV1';

export const createTableDefinitionOutputV1 = (count: number) =>
  ({
    name: `table${count}`,
    type: 'TableDefinition',
  }) satisfies Partial<TableDefinitionOutputV1>;
